import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

// Floating side CTA — appears once the visitor has scrolled past the hero,
// stays gently visible on every public page, and disappears when the user
// is already on the reading tool itself (where it would be redundant).
export default function FloatingReadingCta() {
  const navigate = useNavigate();
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Show as soon as the visitor has scrolled past the very top of the hero.
    // Threshold is intentionally low so the CTA is visible *during* the scroll
    // itself, not only when the user pauses or scrolls back up.
    const onScroll = () => {
      setVisible(window.scrollY > 120);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Hide on the tool page itself, on any reset-password / admin / saved
  // pages (they have their own primary action), and on legal pages.
  const hiddenPaths = ['/tool', '/admin', '/reset-password', '/saved', '/family', '/privacy', '/terms'];
  if (hiddenPaths.some(p => location.pathname.startsWith(p))) return null;
  if (!visible) return null;

  return (
    <button
      type="button"
      className="floating-reading-cta"
      onClick={() => navigate('/tool')}
      aria-label="Get your reading"
      data-testid="floating-reading-cta"
    >
      <span className="floating-reading-cta-icon" aria-hidden="true">✦</span>
      <span className="floating-reading-cta-label">Get your reading</span>
    </button>
  );
}
